import { useConfigStore } from "@stores/useConfigStore";
import React from "react";

export type CanEditProps = {
  hide?: boolean
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>
  innerProps?: React.HTMLAttributes<HTMLDivElement>
  isPatientReadOnly?: string
}

export type BlockSectionProps = React.HTMLAttributes<HTMLDivElement> & {
  innerProps?: React.HTMLAttributes<HTMLDivElement>
}

const BlockSection: React.FC<BlockSectionProps> = ({ children, style, innerProps, ...wrapperProps  }) => {
  return (
    <div
      style={
        {
          cursor: 'not-allowed',
          ...(style || {})
        }
      }
      {...wrapperProps}
    >
      <div
        {...innerProps}
        style={
          {
            pointerEvents: 'none',
            ...(innerProps?.style || {})
          }
        }
      >
        {children}
      </div>
    </div>
  )
}

export const CanEdit: React.FC<CanEditProps> = ({ hide = true, wrapperProps = {}, innerProps = {}, children, isPatientReadOnly }) => {
  const [
    canEdit
  ] = useConfigStore(
    (store) => [store.canEdit]
  )

  const blockEdit = hide ? <></> : <BlockSection {...wrapperProps} innerProps={innerProps}>{children}</BlockSection>

  return  canEdit(isPatientReadOnly) ? <>{children}</> : <>{blockEdit}</> 
}
